<template>
  <div data-app>
    <div class="uk-card uk-card-default uk-animation-fade">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_page_salary }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">

        <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1 uk-margin" data-uk-grid>
          <!--выбор года и недели-->
          <div>
            <div class="uk-grid" data-uk-grid>
              <div>
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div>
                    {{ local_page_keys.year }}
                  </div>
                  <div>
                    <select v-model="selectedYear" class="uk-select">
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                  <div>
                    {{ local_page_keys.week }}
                  </div>
                  <div>
                    <select class="uk-select" v-model="selectedWeek">
                      <option v-for="number in 52" :value="number" :key="number">
                        {{ number }} {{ local_page_keys.week }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--выбор даты-->
          <div v-show="false">
            <div>
              {{ local_page_keys.lable_period_select }}:
            </div>
            <div class="uk-margin-small-top">
              <DatepickerDialog
                  :dateTimePeriod=dateTimePeriod
                  :choosenPeriod.sync=choosenPeriod
                  :getPeriod=getPeriod
                  :todayDate=todayDate></DatepickerDialog>
            </div>
          </div>
          <!--выбор роли-->
          <div>
            <div>{{ local_page_keys.lable_role_select }}:</div>
            <div class="uk-margin-small-top">
              <v-select
                  :options="roles"
                  name="choosenRole" ref="choosenRole" id="choosenRole"
                  label="text"
                  :closeOnSelect="false"
                  :reduce="role => role.value"
                  @input="showUserSelect"
                  :clearable="false"
                  multiple
                  v-model="choosenRole"
                  class="tm-v-select">
              </v-select>

            </div>
          </div>
          <!--выбор пользователя-->
          <div>
            <div v-if="Object.keys(chosenUsers).length > 0" :mdClearable="true">
              <div>{{ local_page_keys.lable_users_select }}:</div>
              <div class="uk-margin-small-top">
                <v-select
                    :options="chosenUsers"
                    ref="usersSelect" name="usersSelect" id="usersSelect"
                    label="email"
                    multiple
                    :reduce="user => user.id"
                    @input="showUserslist"
                    :closeOnSelect="false"
                    :clearable="true"
                    v-model="reportedUsers"
                    class="tm-v-select">
                  <template v-slot:option="option">
                    <span v-if="!option.group">{{ option.name + "(" + option.email + ")" }}</span>
                    <span v-else>{{ option.email }}</span>
                  </template>

                </v-select>

              </div>
            </div>
          </div>
          <!--кнопка-->
          <div v-if="reportedUsers.length > 0">
            <button class="uk-button uk-button-success" type="button" @click="getReport">
              {{ local_page_keys.lable_button_show_report }}
            </button>
            <hr class="uk-margin-medium-top uk-margin-medium-bottom">
          </div>
        </div>

        <!--заголовок выбранного периода-->
        <div v-if="sortedData.length > 0" class="uk-text-center uk-margin">
          <div class="uk-text-large">
            {{ local_page_keys.table_report_title }} - {{ choosenPeriod[0] + '~' + choosenPeriod[1] }}
          </div>
          <div class="uk-margin">
            <button class="uk-button tm-button-grey" type="button" disabled="disabled">
              {{ local_page_keys.disabled_button_not_payed }}
            </button>
          </div>
        </div>

        <!--таблица-->
        <v-card v-if="sortedData.length > 0 && false">
          <v-tabs
              v-model="tab"
              background-color="primary"
              dark>
            <v-tab
                v-for="role in sortedData"
                :key="role.tab">
              {{ role.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="role in sortedData"
                :key="role.tab">
              <v-card flat>
                <v-card-text>
                  <SalarySortedTable
                      :check_boxes_need="true"
                      :local_page_keys="local_page_keys"
                      :headers="getHeaders(role.tab)"
                      :sortedData="role.content"
                      @select_to_pay="select_to_pay = $event"></SalarySortedTable>
                  <button v-if="select_to_pay.length > 0 && thisRoleSelected(role.value)" type="button"
                          class="uk-button uk-button-success" @click="writePayedRetouchers">
                    {{ local_page_keys.button_mark_as_payed }}
                  </button>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>

        <!--НОВЫЕ ТАБЫ-->
        <ul v-if="sortedData && Object.keys(sortedData).length > 0"
            class="uk-grid uk-grid-collapse uk-grid-divider tm-switcher uk-background-muted">
          <template v-for="role in roles">
            <li :key="role.value" :class="activeTab === role.value ? 'uk-active' : ''">
              <a class="uk-padding-xsmall uk-display-block" href="#" @click="changeTab(role.value)">
                {{ role.text }}
              </a>
            </li>
          </template>
        </ul>
        <!--НОВЫЕ ТАБЛИЦЫ-->
        <ul v-if="sortedData && Object.keys(sortedData).length > 0" class="uk-switcher uk-margin switcher-container1">
          <!--таблица-->
          <li v-for="role in roles" :key="role.value" :class="activeTab === role.value ? 'uk-active' : ''">
            <!--шапка-->
            <div
                class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-bold uk-text-meta uk-text-center"
                data-uk-grid>
              <div style="width: 50px" v-if="showField(role.value, 'checked')">
                <!--                <div class="uk-padding-xsmall">-->
                <!--                  <input class="uk-checkbox" type="checkbox" name="users" data-uk-tooltip="Выбрать всех"-->
                <!--                         v-model="selectAll">-->
                <!--                </div>-->
              </div>
              <div class="uk-width-expand">
                <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle tm-child-width-1-9" data-uk-grid>
                  <div v-if="showField(role.value, 'user')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.user }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'sum_for_orders')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.sum_for_orders }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'number_of_orders')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.number_of_orders }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'amount_for_waiting')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.amount_for_waiting }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'number_of_waiting_minutes')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.number_of_waiting_minutes }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'salary_bonus')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.salary_bonus }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'bonus_for_schedule')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.bonus_for_schedule }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'whole_sum')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.whole_sum }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'status')">
                    <div class="uk-padding-xsmall">
                      {{ local_page_keys.status }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="uk-margin-small">
            <!--строки-->
            <div class="uk-grid uk-grid-collapse uk-child-width-1-3 uk-flex-middle tm-grid-bg-hover" data-uk-grid
                 v-for="(row, key) in sortedData[role.value]" :key="key">
              <!--0-->
              <div style="width: 50px" v-if="showField(role.value, 'checked')">
                <div class="uk-padding-xsmall uk-text-center">
                  <input class="uk-checkbox" type="checkbox" name="users[]" :value="row.user_id"
                         v-model="select_to_pay">
                </div>
              </div>
              <div class="uk-width-expand">
                <div class="uk-grid uk-grid-collapse uk-flex-middle tm-child-width-1-9" data-uk-grid>
                  <!--1-->
                  <div v-if="showField(role.value, 'user')">
                    <div class="uk-padding-xsmall uk-text-truncate"
                         :data-uk-tooltip="'#' + row.user_id + ' ' + row.email">
                      {{ "#" + row.user_id + " " + row.email }}
                    </div>
                  </div>
                  <!--2-->
                  <div class="uk-text-center" v-if="showField(role.value, 'sum_for_orders')">
                    <div class="uk-padding-xsmall">
                      {{ row.sum_for_orders }}
                    </div>
                  </div>
                  <!--3-->
                  <div v-if="showField(role.value, 'number_of_orders')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.number_of_orders }}
                    </div>
                  </div>
                  <!--4-->
                  <div v-if="showField(role.value, 'amount_for_waiting')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.amount_for_waiting }}
                    </div>
                  </div>
                  <!--5-->
                  <div v-if="showField(role.value, 'number_of_waiting_minutes')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.number_of_waiting_minutes }}
                    </div>
                  </div>
                  <!--6-->
                  <div v-if="showField(role.value, 'salary_bonus')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.salary_bonus }}
                    </div>
                  </div>
                  <!--7-->
                  <div v-if="showField(role.value, 'bonus_for_schedule')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.bonus_for_schedule }}
                    </div>
                  </div>
                  <!--8-->
                  <div v-if="showField(role.value, 'whole_sum')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.whole_sum }}
                    </div>
                  </div>
                  <div v-if="showField(role.value, 'status')">
                    <div class="uk-padding-xsmall uk-text-center">
                      {{ row.status ? local_page_keys.paid : local_page_keys.not_paid }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </li>
        </ul>
        <button v-if="select_to_pay.length > 0" type="button" :disabled="disabledButtonForPayed"
                class="uk-button uk-button-success" @click="writePayedRetouchers">
          {{ local_page_keys.button_mark_as_payed }}
        </button>

        <!--прилодер-->
        <div v-if="loading">
          <v-progress-circular
              :width="2"
              indeterminate
              style="color: forestgreen"
          ></v-progress-circular>
        </div>
      </div>
    </div>

    <!--Выплаты за неделю-->
    <div class="uk-card uk-card-default uk-width-1-1 uk-animation-fade" v-if="false">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              Выплаты за неделю
            </h3>
          </div>
        </div>
      </div>

      <div class="uk-card-body">
        <!--слайдер недель-->
        <div class="uk-margin-medium uk-light uk-text-center uk-text-bold tm-background-green">
          <div class="uk-slider uk-position-relative" data-uk-slider="draggable: true;sets: false; center: true;">
            <ul class="tm-salary-slider-items uk-child-width-auto uk-grid uk-grid-collapse uk-grid-divider uk-slider-items"
                ref="weekSwitcher"
                data-uk-switcher="swiping:true; connect: .switcher-container; animation: uk-animation-fade; ">
              <li @click="chooseWeek(week)"
                  v-for="(week, index) in weeksLeft"
                  :class="{ 'tm-active-week': week.number === usedWeekNumber }"
                  :key="index">
                <a class="uk-padding-xsmall uk-display-block" :data-uk-tooltip="week.title"
                   href="#">{{ week.number }}</a>
              </li>
              <li @click="chooseWeek(week)"
                  v-for="(week, index) in weeksRight"
                  :class="{ 'tm-active-week': week.number === usedWeekNumber }"
                  :key="index">
                <a class="uk-padding-xsmall uk-display-block" :data-uk-tooltip="week.title"
                   href="#">{{ week.number }}</a>
              </li>
            </ul>
            <a class="uk-position-center-left" href="#" data-uk-slidenav-previous data-uk-slider-item="previous">
              <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg">
                <polyline fill="none" stroke="#000" stroke-width="1.4" points="12.775,1 1.225,12 12.775,23 "></polyline>
              </svg>
            </a>
            <a class="uk-position-center-right" href="#" data-uk-slidenav-next data-uk-slider-item="next">
              <svg width="14" height="24" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg">
                <polyline fill="none" stroke="#000" stroke-width="1.4" points="1.225,23 12.775,12 1.225,1 "></polyline>
              </svg>
            </a>
          </div>
        </div>
        <!--выбор роли-->
        <div class="uk-margin-medium uk-width-large">
          <label for="roleForWeek">Выбрать роль:</label>
          <select class="uk-select" v-model="roleForWeek" name="roleForWeek" ref="roleForWeek" id="roleForWeek"
                  @change="showWeekRole">
            <option v-for="option of roles"
                    :key="option.index"
                    :value="option.text"
            >{{ option.text }}
            </option>
          </select>
        </div>
        <!--шапка таблицы-->
        <div v-if="showWeek"
             class="uk-grid uk-grid-collapse uk-child-width-1-3 uk-flex-middle uk-text-center uk-text-uppercase"
             data-uk-grid>
          <div class="uk-width-auto">
            <div class="uk-padding-small uk-text-bold uk-text-meta">
              <input class="uk-checkbox" type="checkbox" data-uk-tooltip="Выделить/отменить все"
                     v-model="listForWeekCheckAll" @click="listForWeekCheckAllAction">
            </div>
          </div>
          <div class="uk-width-expand">
            <div class="uk-padding-small uk-text-bold uk-text-meta">Имя</div>
          </div>
          <div>
            <div class="uk-padding-small uk-text-bold uk-text-meta">Сумма за заказы</div>
          </div>
          <div>
            <div class="uk-padding-small uk-text-bold uk-text-meta">Простой</div>
          </div>
        </div>
        <hr class="uk-margin-small">
        <!--таблица-->
        <ul v-if="showWeek" class="uk-switcher switcher-container uk-margin-medium">
          <!--неделя 1-->
          <li v-for="week in weeks" :key="week.index">
            <!--таблица-->
            <div>
              <!--строка-->
              <div v-for="(user, user_index) in listForWeek" :key="user.index"
                   class="uk-grid uk-grid-collapse uk-child-width-1-3 uk-flex-middle tm-grid-bg-hover"
                   :class="{ 'tm-unchecked-user': listForWeek[user_index].check == false}"
                   data-uk-grid>
                <div class="uk-width-auto">
                  <div class="uk-padding-small">
                    <input @click="listForWeekRowCheck(user_index)" class="uk-checkbox" type="checkbox"
                           v-model="listForWeek[user_index].check">
                  </div>
                </div>
                <div class="uk-width-expand">
                  <div class="uk-padding-small">
                    <label>{{ user.name }}</label>
                  </div>
                </div>
                <div>
                  <div :id=user.user_id class="uk-padding-small">
                    <input class="uk-input uk-text-center"
                           :id="user.user_id"
                           :name="'data['+user_index+'][sum_week]'"
                           type="text" aria-label="Input"
                           @input="validateDecimalInput(user_index, 'sum_week')"
                           v-model="listForWeek[user_index].sum_week">
                    <span v-if="!listForWeek[user_index]['sum_week' + '_isValid']" class="error">Invalid input. Please enter numbers (with two decimal).</span>
                  </div>
                </div>
                <div>
                  <div class="uk-padding-small">
                    <input class="uk-input uk-text-center"
                           :id="user.user_id"
                           :name="'data['+user_index+'][sum_downtime]'"
                           type="text" aria-label="Input"
                           @input="validateDecimalInput(user_index, 'sum_downtime')"
                           v-model="listForWeek[user_index].sum_downtime">
                    <span v-if="!listForWeek[user_index]['sum_downtime' + '_isValid']" class="error">Invalid input. Please enter numbers (with two decimal).</span>
                  </div>
                </div>
              </div>
              <!--строка-->
            </div>
          </li>
        </ul>
      </div>

      <div class="uk-card-footer">
        <button type="button" class="uk-button tm-button-success" @click="saveWeekData">Сохранить<span
            v-if="loadingWeek" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span></button>
      </div>
    </div>

  </div>
</template>

<script>
import SalarySortedTable from "@/pages/Dashboard/Components/SalarySortedTable";
import DatepickerDialog from "@/pages/Dashboard/Components/Admin/DatepickerDialog.vue";

export default {
  components: {
    SalarySortedTable,
    DatepickerDialog
  },
  data() {
    return {
      headers: [
        {
          text: 'User name',
          value: 'user_name',
        },
        {
          text: 'Role',
          value: 'user_role',
        },
        {
          text: 'Number of orders',
          value: 'orders_count',
        },
        {
          text: 'Order`s price',
          value: 'total_orders_price',
        },
        {
          text: 'Client`s tips',
          value: 'clients_tips',
        },
        {
          text: 'Summ',
          value: 'all_amount',
        },
      ],
      headers_empty: [
        {
          text: '',
          align: 'start',
          value: 'user_name'
        },
        {
          text: '',
          align: 'center',
          value: 'empty_base'
        }
      ],
      fields: {
        'retoucher': [
          'checked',
          'user',
          'sum_for_orders',
          'amount_for_waiting',
          'bonus_for_schedule',
          'number_of_orders',
          'number_of_waiting_minutes',
          'salary_bonus',
          'status',
          'whole_sum'
        ],
        'junior-retoucher': [
          'checked',
          'user',
          'sum_for_orders',
          'amount_for_waiting',
          'bonus_for_schedule',
          'number_of_orders',
          'number_of_waiting_minutes',
          'salary_bonus',
          'status',
          'whole_sum'
        ],
        'pro-retoucher': [
          'user'
        ],
        'senior-retoucher': [
          'user',
          'number_of_orders'
        ],
      },
      showDateRangePiecker: false,
      dialogVisible: false,
      loading: false,
      loadingWeek: false,
      showWeek: true,
      empty_base: false,
      search: '',
      local_page_keys: {},
      todayDate: '',
      choosenPeriod: [],
      choosenRole: [],

      roles: [
        {
          text: "retouchers",
          value: "retoucher"
        },
        {
          text: "pro-retouchers",
          value: "pro-retoucher"
        },
        {
          text: "junior-retouchers",
          value: "junior-retoucher"
        },
        {
          text: "senior-retouchers",
          value: "senior-retoucher"
        },
      ],
      listByRoles: {},
      chosenUsers: {},
      reportedUsers: [],
      tab: null,
      tabPayed: null,
      sortedData: [],
      sortedPayed: [],
      startTime: '00:00',
      endTime: '24:00',
      select_to_pay: [],
      requestedUsers: [],

      weeks: {},
      weeksRight: {},
      weeksLeft: {},
      usedWeek: {},
      usedWeekNumber: 1,
      roleForWeek: null,
      listForWeek: [],
      listForWeekCheckAll: true,
      getterKey: 0,
      date: new Date(),
      selectedWeek: 1,
      currentWeek: 1,
      selectedYear: (new Date()).getFullYear(),
      activeTab: 'retoucher',
      selectedFilter: {
        week: -1,
        year: -1,
      },
      serverTime: {},
      targetPaymentTime: "8:10:00"
    };
  },
  computed: {
    dateTimePeriod() {
      return this.choosenPeriod[0] + ' ' + '~' + this.choosenPeriod[1];
    },
    disabledButtonForPayed() {
      return (this.currentWeek === this.selectedFilter.week && (new Date()).getFullYear() === this.selectedFilter.year);
    }
  },

  methods: {
    validateDecimalInput(user_index, option) {

      const regex = /^-?\d*\.{0,1}\d{0,2}$/; // Regular expression to match numbers with at most two decimal places
      //console.log(this.listForWeek[user_index][option]);
      const match = (this.listForWeek[user_index][option]).match(regex);

      let lastMatch;
      if (match) lastMatch = match;

      if (this.listForWeek[user_index][option].length == 0 || (match && typeof match[0] !== 'undefined' && match[0] != '')) {
        this.listForWeek[user_index][option] = lastMatch;
        this.listForWeek[user_index][option + '_lastValid'] = lastMatch[0];
        this.listForWeek[user_index][option + '_isValid'] = true;
        if (match[0] == '-' || match[0] == '-.') {
          this.listForWeek[user_index] = {...this.listForWeek[user_index], [`${option}_isValid`]: false};
        }
      } else {

        if (option + '_lastValid' in this.listForWeek[user_index] && this.listForWeek[user_index][option + '_lastValid']) {
          this.listForWeek[user_index][option] = this.listForWeek[user_index][option + '_lastValid'];
        } else {
          this.listForWeek[user_index][option] = '';
        }

        const inputElement = this.$el.querySelector('input[name="data[' + user_index + '][' + option + ']"]');
        inputElement.value = this.listForWeek[user_index][option];

        if (this.listForWeek[user_index][option + '_lastValid'] != this.listForWeek[user_index][option]) {

          this.listForWeek[user_index][option + '_isValid'] = false;

          this.listForWeek[user_index] = {...this.listForWeek[user_index], [`${option}_isValid`]: false};
        }
      }
    },
    listForWeekRowCheck(value) {
      this.listForWeek[value] = {...this.listForWeek[value], check: !this.listForWeek[value].check};
    },
    listForWeekCheckAllAction() {
      let _this = this;
      Object.keys(this.listForWeek).forEach(key => {
        _this.listForWeek[key] = {..._this.listForWeek[key], check: !_this.listForWeekCheckAll};
      });
    },
    async showUserSelect() {
      if (this.choosenRole.includes('all')) {
        for (let role of this.roles) {
          if (!this.choosenRole.includes(role.value)) this.choosenRole.push(role.value)
        }
      }

      this.loading = !this.loading;
      this.chosenUsers = [];
      this.reportedUsers = [];
      this.sortedData = [];
      this.sortedPayed = [];
      try {
        let roles = this.choosenRole;
        if (roles.includes('all')) {
          roles.splice(roles.indexOf('all'), 1)
        }
        await this.$store.dispatch("users/chosenRolesUsersList", {roles,  without_trash: true});
        let data = await this.$store.getters['users/chosenRolesUsersList'];
        this.chosenUsers = Object.values(data).sort((a, b) => (a.role > b.role) ? 1 : ((b.role > a.role) ? -1 : 0))
            .reduce(function (total, item, index, array) {
              if (!array[index - 1] || (array[index - 1].role && array[index - 1].role !== item.role)) {
                total.push({
                  email: item.role.toUpperCase(),
                  name: '',
                  group: true,
                  id: item.role,
                })
              }
              total.push(item);
              return total;
            }, []);
        this.chosenUsers.unshift(
            {
              email: 'ALL',
              name: '',
              group: true,
              id: 'all'
            });
        this.loading = !this.loading;
      } catch (e) {
        this.loading = !this.loading;
        alert(this.local_page_keys.alert_failed_salary_data)
      }

    },
    async showUserSelectForWeek() {
      if (this.choosenRole.includes('all')) {
        for (let role of this.roles) {
          if (!this.choosenRole.includes(role.value)) this.choosenRole.push(role.value)
        }
      }

      this.loading = !this.loading;
      this.chosenUsers = [];
      this.reportedUsers = [];
      this.sortedData = [];
      this.sortedPayed = [];
      try {
        let roles = this.choosenRole;
        if (roles.includes('all')) {
          roles.splice(roles.indexOf('all'), 1)
        }
        await this.$store.dispatch("users/chosenRolesUsersList", {roles,  without_trash: true});
        let data = await this.$store.getters['users/chosenRolesUsersList'];
        this.chosenUsers = data;
        this.loading = !this.loading;
      } catch (e) {
        this.loading = !this.loading;
        alert(this.local_page_keys.alert_failed_salary_data)
      }

    },
    getPeriod() {
      this.choosenPeriod.sort();
    },
    getRolesList() {
      if (this.choosenRole.includes('all')) {
        return ['retoucher', 'pro-retoucher', 'junior-retoucher']
      }
      return this.choosenRole;
    },
    getUsersGroupeList(role) {
      let usersOfRole = [];
      for (let user of Object.values(this.chosenUsers)) {
        if (user.role === role) {
          usersOfRole.push(user)
        }
      }
      return usersOfRole;
    },
    showUserslist() {
      for (let role of this.getRolesList()) {
        if (this.reportedUsers.includes('all') && !this.reportedUsers.includes(role)) {
          this.reportedUsers.push(role);
        }
        if (this.reportedUsers.includes(role)) {
          for (let user of this.getAllOfRoles(role)) {
            if (!this.reportedUsers.includes(user)) {
              this.reportedUsers.push(user);
            }
          }
        }
        this.reportedUsers = this.reportedUsers.filter(value => value !== role);
      }
      this.reportedUsers = this.reportedUsers.filter(value => value !== 'all');
    },
    getAllOfRoles(role) {
      let users = this.getUsersGroupeList(role)
      let allUsers = [];
      for (let user of Object.values(users)) {
        allUsers.push(user.id)
      }
      return allUsers;
    },
    async getReport() {
      this.sortedData = [];
      this.sortedPayed = [];
      let formData = new FormData();
      for (let role of this.getRolesList()) {
        if (this.reportedUsers.includes(role)) {
          this.reportedUsers.splice(this.reportedUsers.indexOf(role), 1)
        }
      }
      if (this.reportedUsers.includes('allUsers')) {
        this.reportedUsers.splice(this.reportedUsers.indexOf('allUsers'), 1)
      }
      this.requestedUsers = this.reportedUsers;
      // formData.append('start_date', this.choosenPeriod[0] + ' ' + this.startTime);
      // formData.append('end_date', this.choosenPeriod[1] + ' ' + this.endTime);
      formData.append('week', this.selectedWeek);
      formData.append('year', this.selectedYear);

      for (let i = 0; i < this.reportedUsers.length; i++) {
        formData.append('users_ids[' + i + ']', this.reportedUsers[i]);
      }

      this.loading = true;
      try {
        await this.$store.dispatch("salary/reportSalaryData", formData);
        let data = await this.$store.getters['salary/reportSalaryData'];
        this.sortedData = data.users;
        this.selectedFilter.week = this.selectedWeek;
        this.selectedFilter.year = this.selectedYear;
        this.loading = false;
      } catch (e) {
        alert(this.local_page_keys.alert_failed_salary_data);
        this.loading = false;
      }
    },
    getHeaders(data) {
      let headers = [];
      switch (data) {
        case 'retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
            {
              text: this.local_page_keys.table_head_total_orders_price,
              value: 'total_orders_price',
            },
            {
              text: this.local_page_keys.table_head_clients_tips,
              value: 'clients_tips',
            },
            {
              text: this.local_page_keys.table_head_all_amount,
              value: 'all_amount',
            },
          ];
          break;
        case 'junior-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
            {
              text: this.local_page_keys.table_head_total_orders_price,
              value: 'total_orders_price',
            },
            {
              text: this.local_page_keys.table_head_clients_tips,
              value: 'clients_tips',
            },
            {
              text: this.local_page_keys.table_head_all_amount,
              value: 'all_amount',
            },
          ];
          break;
        case 'pro-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
          ];
          break;
        case 'senior-retoucher':
          headers = [
            {
              text: this.local_page_keys.table_head_user_name,
              value: 'user_name'
            },
            {
              text: this.local_page_keys.table_head_user_role,
              value: 'user_role'
            },
            {
              text: this.local_page_keys.table_head_count_bad_job,
              value: 'count_bad_job',
            },
            {
              text: this.local_page_keys.table_head_count_nice_job,
              value: 'count_nice_job',
            },
            {
              text: this.local_page_keys.table_head_orders_count,
              value: 'orders_count',
            },
          ];
          break;

      }
      return headers;

    },
    customSort() {
      return false;
    },
    showTimePeriod() {
      setTimeout(() => {
        this.showDateRangePiecker = !this.showDateRangePiecker;
      }, 500)
    },
    thisRoleSelected(data) {
      for (let item of data) {
        if (this.select_to_pay.includes(item.user_id)) {
          return true;
        }
      }
      return false;
    },
    async writePayedRetouchers() {
      await this.fetchServerTime();
      if (! this.allowOperationByTime()) {
        alert('Выплаты разрешены только после ' + this.targetPaymentTime +' GMT+3');
      }
      else {
        if (confirm(this.local_page_keys.confirm_mark_as_payed)) {
          let formdata = new FormData();
          // formdata.append('date_start', this.choosenPeriod[0]);
          // formdata.append('date_end', this.choosenPeriod[1]);
          formdata.append('year', this.selectedYear);
          formdata.append('week', this.selectedWeek);
          for (let i = 0; i < this.select_to_pay.length; i++) {
            formdata.append('user_ids[' + i + ']', this.select_to_pay[i]);
          }
          await this.$store.dispatch('salary/writePayedRetouchers', formdata);
          let data = await this.$store.getters['salary/writePayedRetouchers'];
          if (data.status === 'ok') {
            this.reportedUsers = this.requestedUsers;
            await this.getReport();
            alert("Success");
          } else if (data.status === 'error') {
            alert(data.message);
          }
        }
      }
    },
    clearDatas() {
      this.sortedPayed = [];
      this.sortedData = [];
    },
    async getListByRoles() {
      let roles = this.roles;
      let listByRoles = {};
      for (const element of roles) {
        await this.$store.dispatch("users/chosenRolesUsersList", {roles: [element.value],  without_trash: true});
        listByRoles[element.text] = await this.$store.getters['users/chosenRolesUsersList'];
      }
      this.listByRoles = listByRoles;
    },
    async showWeekRole() {

      let _this = this;
      if (null == this.roleForWeek) {
        return
      }
      await this.getListByRoles();
      // this.showWeek=false
      // this.loadingWeek=true
      let listForWeek = [];
      listForWeek = this.listByRoles[this.roleForWeek]
      let userIds = []
      Object.entries(listForWeek).forEach(([key, value]) => {
        userIds.push(value.id);
      });

      let weekData = await this.getWeekData();
      userIds.forEach(value => {
        let a = weekData.find(wd => wd.user_id === value
            && (_this.usedWeek.year).toString() === (wd.year).toString()
            && (_this.usedWeek.number).toString() === (wd.num_week).toString()
        );

        if (a === undefined) {
          //return;
          listForWeek[value].sum_week = '';
          listForWeek[value].sum_downtime = '';
        } else {
          listForWeek[value].sum_week = a.sum_week != 'null' ? a.sum_week : '';
          listForWeek[value].sum_downtime = a.sum_downtime != 'null' ? a.sum_downtime : '';
        }
        listForWeek[value].sum_week_isValid = true;
        listForWeek[value].sum_week_lastValid = listForWeek[value].sum_week;
        listForWeek[value].sum_downtime_isValid = true;
        listForWeek[value].sum_downtime_lastValid = listForWeek[value].sum_downtime;
        listForWeek[value].check = true;

      });

      this.listForWeek = listForWeek;
      this.listForWeekCheckAll = true;

      //console.log(listForWeek);
    },
    async getWeekData() {
      let formData = new FormData();
      formData.append('week', this.usedWeek.number);
      await this.$store.dispatch("salary/getWeekData", formData);
      this.getterKey++;

      return await this.$store.getters['salary/getWeekData'](this.getterKey);
    },
    async saveWeekData() {
      this.loadingWeek = true;
      if (Object.keys(this.listForWeek).length > 0) {
        let result = await this.saveWeekDataToDb();
        if (!result.hasOwnProperty('error')) {
          UIkit.notification({message: 'Данные сохранены!', pos: 'top-center', status: 'success', timeout: 1500});
        } else {
          UIkit.notification({
            message: 'Данные не сохранены!' + ' ' + String(result.error),
            pos: 'top-center',
            status: 'warning',
            timeout: 1500
          });
        }
      }
      this.loadingWeek = false;
    },
    async saveWeekDataToDb() {
      if (Object.keys(this.listForWeek).length > 0) {
        let formData = new FormData();
        let rowCounter = 0;
        let rowIsValid = true;
        for (let row in this.listForWeek) {

          if (this.listForWeek[row].check === true) {
            for (let col in this.listForWeek[row]) {
              formData.append('data[' + row + '][' + col + ']', this.listForWeek[row][col]);
              if (col.indexOf('_isValid') > -1 && this.listForWeek[row][col] !== true) {
                rowIsValid = false;
              }
            }
            formData.append('data[' + row + '][user_id]', this.listForWeek[row]['id']);
            formData.append('data[' + row + '][num_week]', this.usedWeek['number']);
            formData.append('data[' + row + '][year]', this.usedWeek['year']);
          }
          rowCounter++;
        }

        if (!rowIsValid) return {error: 'Проверьте вводные данные, могут быть минусы'}
        if (rowCounter == 0) return {error: 'Отметьте хотя бы один CheckBox'}
        await this.$store.dispatch("salary/storeWeek", formData);

        return await this.$store.getters['salary/storeWeek']
      }
    },
    async chooseWeek(week) {
      await this.useWeek(week.number, week.first, week.last, week.year);
      await this.showWeekRole();
      this.usedWeekNumber = week.number;
      //console.log(week);
    },
    useWeek(number, first, last, year) {
      this.usedWeek['number'] = number;
      this.usedWeek['first'] = first;
      this.usedWeek['last'] = last;
      this.usedWeek['year'] = year;
    },
    getListOfWeeks() {
      let date = new Date();
      let year = date.getFullYear();
      let numOfWeeks = this.getNumOfWeeks(year);
      let weeks = {};
      const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
      for (let i = 1; i <= numOfWeeks; i++) {
        let daysOfWeek = this.getDaysOfWeek(i, year);
        let first = new Date(daysOfWeek.shift());
        let last = new Date(daysOfWeek.pop());
        const formattedDateFirst = first.toLocaleDateString('en-GB', options).replace(/\//g, '.');
        const formattedDateLast = last.toLocaleDateString('en-GB', options).replace(/\//g, '.');
        let week = {};
        week['title'] = 'title: ' + formattedDateFirst + " - " + formattedDateLast;
        week['first'] = formattedDateFirst;
        week['last'] = formattedDateLast;
        week['number'] = i;
        week['year'] = year;
        weeks[i] = week;
      }

      this.weeks = weeks;
      this.sortListOfWeeksFromUsedWeekNumber();
      let week = weeks[1];
      this.useWeek(week.number, week.first, week.last, week.year);
    },
    sortListOfWeeksFromUsedWeekNumber() {
      let _this = this;
      let leftObj = {};
      let rightObj = {};
      if (this.usedWeekNumber > 1) {
        let leftObjIter = 1;
        let rightObjIter = 1;
        Object.keys(this.weeks).forEach(key => {
          if (_this.weeks[key].number >= _this.usedWeekNumber) {
            rightObj[Number(rightObjIter) + Number(_this.usedWeekNumber)] = (_this.weeks[key]);
            rightObjIter++;
          }
          if (_this.weeks[key].number < _this.usedWeekNumber) {
            leftObj[leftObjIter] = (_this.weeks[key]);
            leftObjIter++;
          }
        });
        if (Object.keys(rightObj).length > 0) this.weeksLeft = rightObj;
        if (Object.keys(leftObj).length > 0) this.weeksRight = leftObj;
      }
    },
    getNumOfWeeks(year) {
      var startDateOfYear = new Date(year, 0, 1);

      var daysOfYear =
          (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 366 : 365;

      var daysToNextSunday = (7 - startDateOfYear.getDay()) % 7;

      var daysFromPrevSaturday = startDateOfYear.getDay();

      var daysAfterLastSunday = (daysOfYear - daysToNextSunday) % 7;

      return (daysOfYear - daysToNextSunday - daysFromPrevSaturday - daysAfterLastSunday) /
          7 +
          (daysToNextSunday >= daysFromPrevSaturday ? 1 : 0);
    },
    getDaysOfWeek(weekNumber, year) {
      const date = new Date(year, 0, 1 + (weekNumber - 1) * 7);
      const days = [];
      for (let i = 0; i < 7; i++) {
        const day = new Date(date.getFullYear(), date.getMonth(), date.getDate() + i);
        days.push(day);
      }
      return days;
    },
    getCurrentWeekNumber() {
      const now = new Date();
      const startOfYear = new Date(now.getFullYear(), 0, 1);
      const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000;
      const millisecondsSinceStartOfYear = now - startOfYear;
      let currentWeek = Math.ceil(millisecondsSinceStartOfYear / millisecondsPerWeek);
      this.usedWeekNumber = currentWeek;
      this.selectedWeek = currentWeek;
      this.currentWeek = currentWeek;
    },

    async showCurrentWeekNumber() {
      this.usedWeek = JSON.parse(JSON.stringify(this.weeks[this.usedWeekNumber]));
      //cases object relink error
      //this.usedWeek = this.weeks[this.usedWeekNumber];
      let index = this.usedWeekNumber;
      this.activeElement = index;
      this.$nextTick(() => {
        const switcher = UIkit.switcher(this.$refs.weekSwitcher);
        switcher.show(index);

        //this.scrollToElement(index);
      });
    },

    scrollToElement(index) {
      const element = this.$refs.weekSwitcher.children[Number(index)];
      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'start'
        });
      }
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.select_to_pay = [];
    },
    showField(role, field) {
      return this.fields[role] && this.fields[role].indexOf(field) >= 0;
    },
    allowOperationByTime() {
      const responseHourInt = parseInt(this.serverTime.hour, 10);
      const responseMinuteInt = parseInt(this.serverTime.minutes, 10);
      const [targetHour, targetMinute] = this.targetPaymentTime.split(":");
      const targetHourInt = parseInt(targetHour, 10);
      const targetMinuteInt = parseInt(targetMinute, 10);

      if (responseHourInt > targetHourInt || (responseHourInt === targetHourInt && responseMinuteInt >= targetMinuteInt)) {
        return true
      }
      return false;
    },
    async fetchServerTime() {
      try {
        await this.$store.dispatch("schedule/scheduleValidateTime");
        this.getterKey++;
        const response = await this.$store.getters["schedule/scheduleValidateTime"](this.getterKey);
        if(response.linuxTimestamp){
          this.serverTime = response;
        }
      } catch (error) {
        alert('Error fetching server time:' + error);
      }
    },

  },

  async mounted() {
    await this.getCurrentWeekNumber();
    this.local_page_keys = await this.$filtergetLocalisationPage('salary');
    await this.$store.dispatch('salary/defaultPeriod');
    let defaultPeriod = await this.$store.getters['salary/defaultPeriod'];
    this.choosenPeriod.push(defaultPeriod.start_date.slice(0, 10))
    this.choosenPeriod.push(defaultPeriod.end_date.slice(0, 10))
    this.endTime = (defaultPeriod.end_date.slice(-6, -3) + ':00').trim();
    let today = new Date().toJSON();
    this.todayDate = today.slice(0, today.indexOf('T'));

    await this.getListByRoles();
    this.getListOfWeeks();
    await this.showCurrentWeekNumber();
    this.roleForWeek = this.roles[0].text;
    await this.showWeekRole();
  },

}
</script>

<style>
@import '../../../assets/css/uikit/slider.css';
@import '../../../assets/css/uikit/slidenav.css';
@import '../../../assets/css/uikit/switcher.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/uikit/notification.css';

.md-menu.md-select {
  border-bottom: 1px solid #ccc;
}

.tm-salary-slider-items > * {
  width: 100px;
}

.tm-salary-slider-items a.tm-active {
  transition: .3s ease-out;
}

.tm-salary-slider-items li.uk-active a,
.tm-salary-slider-items li.uk-active a:hover,
.tm-salary-slider-items a.tm-active,
.tm-salary-slider-items a:hover {
  background-color: transparent;
}

.tm-salary-slider-items li a {
  background-color: transparent;
}

.tm-salary-slider-items li.tm-active-week a,
.tm-salary-slider-items li a:hover,
.tm-salary-slider-items li.tm-active-week a:hover {
  background-color: #3b8e3f !important;
}


.tm-salary-slider-items.uk-grid-divider > :not(.uk-first-column):before {
  border-left: 1px solid #429d47;
}

.tm-grid-bg-hover:hover {
  transition: .3s ease-out;
  background-color: #eaeaea;
}

.uk-button.tm-button-success {
  background-color: #4caf50;
  color: #fff !important;
}

.uk-button.tm-button-success:hover {
  background-color: #3b8e3f;
  color: #fff !important;
}


.v-date-picker-table .v-btn.v-btn--active {
  color: green;
}

.v-progress-circular {
  display: block;
  width: 100px;
  margin: 0 auto;
}

.weekpicker {
  padding: 1px;
  padding-top: 1em;
}

.tm-salary-table .md-table-head-container,
.tm-salary-table .md-table-head-label {
  white-space: inherit;
}

.tm-salary-table .md-table-head-label,
.tm-salary-table table tr * {
  font-size: 12px;
  line-height: 1.4em;
}

.tm-salary-table .md-table-head,
.tm-salary-table table tr * {
  padding: 6px;
}

.tm-salary-table .md-table-head-container,
.tm-salary-table .md-table-head-label,
.tm-salary-table table tr * {
  height: auto;
}

.tm-salary-table .md-table-head-label,
.tm-salary-table table tr * {
  text-align: center;
}

.tm-salary-table table tbody tr td:first-child > * {
  text-align: left;
}

.tm-salary-table table tr td > *,
.tm-salary-table .md-table-head-label,
.tm-salary-table .md-table-head-container {
  padding: 0;
}

.tm-salary-table .md-table-head-label {
  display: block;
}

.tm-salary-table .md-table-head:last-child:not(:first-child) .md-table-head-label {
  padding-right: 0;
}

.tm-salary-table.md-table .md-table-row:hover .md-table-cell {
  background-color: rgba(0, 0, 0, .08) !important;
}

.tm-salary-table table tr th,
.tm-salary-table table tr td {
  width: 8%;
}

.tm-salary-table table tr th:first-child,
.tm-salary-table table tr td:first-child {
  width: 12%;
}

.md-datepicker-dialog .v-picker__title {
  display: none;
}

.md-table-head-container {
  text-align: center;
}

.md-table-head-label {
  font-weight: bolder;
}

.md-table-cell:first-child {
  text-align: end;
}

.md-table-cell {
  text-align: center;
}

.orange > .v-slide-group__wrapper {
  background-color: darkorange !important;
}

.tm-unchecked-user {
  background-color: #eaeaea !important;
}

</style>